import { HardwareProductsState } from "./types";

const initialState: HardwareProductsState = {
  fetching: false,
  response: {},
};

export default initialState;
